import PendingCompetenciesDialog from './PendingCompetenciesDialog';
export default PendingCompetenciesDialog;